<div
  class="vi-header {{ color }} flex flex-row justify-center items-center"
  [class.shadow]="shadow"
>
  <vi-content
    [gap]="gap"
    [height]="height"
    [layoutAlign]="layoutAlign"
    [direction]="direction"
    [fluid]="fluid"
    [centered]="centered"
  >
    <ng-content main></ng-content>
  </vi-content>
</div>
